var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"login-btn company-member-login",on:{"click":function($event){$event.preventDefault();return _vm.toggleCompanyMemberLoginModal($event)}}},[_vm._v(" 企業會員登入 ")])}
var staticRenderFns = []

export { render, staticRenderFns }